import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/fireabase"; // import your Firestore instance
import { Link } from "react-router-dom";
import Avatar from "../components/Avatar";
import { useNavigate } from "react-router-dom";
import MultiSizeCircles from "../components/MultiSizeCircles";

const AllUsersComponent = ({ allUsers }) => {
  const navigate = useNavigate();
  const [users, setUsers] = useState(allUsers);
  return (
    <div className="flex flex-wrap justify-center gap-10">
      {users.map((user) => (
        <div
          key={user.id}
          style={{
            cursor: "pointer",
            padding: "10px",
            boxShadow: "0px 0px 10px rgba(128,128,128,0.75)",
            borderRadius: "10px",
            width: "200px",
            height: "200px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary-color)",
          }}
          onClick={() => navigate(`/myprofile/${user.id}`)}
        >
          {user.photoURL ? (
            <img
              src={user.photoURL}
              alt="user"
              width="100px"
              height="100px"
              style={{
                borderRadius: "50%",
                filter: "drop-shadow(0px 0px 10px rgba(128,128,128,0.75))",
              }}
            />
          ) : (
            <Avatar Name={user.email} />
          )}
          <h2 style={{ cursor: "pointer" }}>
            <Link to={`/myprofile/${user.id}`}>{user.name || "No Name"}</Link>
          </h2>
        </div>
      ))}
    </div>
  );
};
const AllUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const usersCollection = await getDocs(collection(db, "users"));
      setUsers(
        usersCollection.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      );
    };

    fetchUsers();
  }, []);
  return (
    <React.Fragment>
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          paddingTop: "50px",
        }}
      >
        <h1 className="text-md sm:text-md md:text-xl lg:text-2xl xl:text-3xl font-bold text-center text-white my-5">
          جميع المستخدمين
        </h1>
        <MultiSizeCircles allUsers={users} />
      </div>
    </React.Fragment>
  );
};

export default AllUsers;
